// extracted by mini-css-extract-plugin
module.exports = {"success":"_2z828h","failure":"_1bkFA_"};